import type { Update } from '@ngrx/entity';
import type { Uuid } from '@common/types';
import type { NormalizedColumnEntity, DenormalizedColumnEntity, WidgetCorrelationData } from '@web/types';

import { createActionGroup, props } from '@ngrx/store';

const ColumnsActions = createActionGroup({
    source: 'PageStructure/Columns',
    events: {
        init: props<{ columns: NormalizedColumnEntity[] }>(),
        'Add column': props<{ column: DenormalizedColumnEntity; index: number }>(),
        'Add many columns': props<{ columns: NormalizedColumnEntity[] }>(),
        'Column added': props<{ column: NormalizedColumnEntity; index: number }>(),
        'Create column': props<{
            index: number;
            sectionId: Uuid;
            widgetCorrelationData?: WidgetCorrelationData;
            skipHistory?: boolean;
        }>(),
        'Create specific column': props<{
            index: number;
            sectionId: Uuid;
            widgetCorrelationData?: WidgetCorrelationData;
            skipHistory?: boolean;
        }>(),
        'Column created': props<{
            index: number;
            column: NormalizedColumnEntity;
            skipHistory?: boolean;
        }>(),
        'Copy column': props<{ column: DenormalizedColumnEntity; index: number }>(),
        'Copy many columns': props<{ columns: NormalizedColumnEntity[] }>(),
        'Column copied': props<{
            column: NormalizedColumnEntity;
            columnEntity: DenormalizedColumnEntity;
            index: number;
        }>(),
        'Remove column': props<{ column: DenormalizedColumnEntity; index: number; skipHistory?: boolean }>(),
        'Remove many columns': props<{ columnsIds: string[] }>(),
        'Column moved': props<{
            columnId: Uuid;
            prevSectionId: Uuid;
            currentSectionId: Uuid;
            previousIndex: number;
            currentIndex: number;
            skipHistory?: boolean;
        }>(),
        'Update column properties': props<{ update: Update<NormalizedColumnEntity> }>(),
        'Update columns properties': props<{ update: Update<NormalizedColumnEntity>[] }>(),
        'Append child': props<{ childId: string; order: number }>(),
    },
});

export default ColumnsActions;
